import { CheckCircle2, XCircle } from 'lucide-react';

import { transformEntitlementsToFeatures } from '@/components/modules/plan/utils/';
import { Text } from '@/components/text';
import { UserEntitlementInterface } from '@/types';
import { tv } from '@/utils/styles';

import { PlanItemInclusion } from '../inclusion';

interface PlanItemInclusionsProps {
  entitlements?: UserEntitlementInterface;
}

const PlanItemInclusions = ({ entitlements }: PlanItemInclusionsProps) => {
  if (!entitlements) {
    return null;
  }

  const features = transformEntitlementsToFeatures(entitlements, 8, true);

  const { inclusionList, inclusionTitle, inclusionItem } = styles();

  return (
    <div className="mt-4 w-full">
      <Text className={inclusionTitle()}>What&apos;s included</Text>
      <ul className={inclusionList()}>
        {features &&
          features.map((feature) => {
            const isExcluded = feature.excluded;
            return (
              <li className={inclusionItem({ className: isExcluded ? 'text-grey-400' : '' })} key={feature.key}>
                {isExcluded ? (
                  <XCircle className="stroke-grey-350" size={16} />
                ) : (
                  <CheckCircle2 className="stroke-green-500" size={16} />
                )}
                <PlanItemInclusion text={feature.display} limitText={feature.limitText} />
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export const styles = tv({
  slots: {
    inclusionList: 'space-y-1 md:columns-2 md:gap-8',
    inclusionTitle: 'mb-2 text-baseSm font-medium',
    inclusionItem: 'mb-1 flex items-center gap-2 text-sm',
  },
});

export { PlanItemInclusions };
